import request from './request'

/** 规则中心和帮助中心 */

/** 查询所有分类 */
export function queryCategory(type?: number) {
	return request
		.get('/api/article/queryAllCategory')
		.then((data) => data.list?.find((item: any) => item.id === type))
		.then((value) => value.child)
}

/** 查询分类下的文章列表 */
export function queryArticleList(params: any) {
	return request
		.get('/api/article/queryArticleList', { params })
		.then((data) => data.data)
}

/** 文章搜索功能 */
export function searchArticle(params: any) {
	return request
		.get('/api/article/search', { params })
		.then((data) => data.data)
}

/** 文章详情 */
export function queryArticleDetail(params: any) {
	return request.get('/api/article/showDetail', {
		params,
	})
}
